var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconGooglePodcastsLogo = function SvgIconGooglePodcastsLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 1.25a1 1 0 0 1 1 1V4.5a1 1 0 1 1-2 0V2.25a1 1 0 0 1 1-1M16.5 5.375a1 1 0 0 1 1 1v2.25a1 1 0 1 1-2 0v-2.25a1 1 0 0 1 1-1M13 19.5a1 1 0 1 0-2 0v2.25a1 1 0 1 0 2 0zM12 7.25a1 1 0 0 1 1 1v7.5a1 1 0 1 1-2 0v-7.5a1 1 0 0 1 1-1M8.5 6.375a1 1 0 0 0-2 0v5.25a1 1 0 1 0 2 0zM16.5 11.375a1 1 0 0 1 1 1v5.25a1 1 0 1 1-2 0v-5.25a1 1 0 0 1 1-1M4 10.875a1 1 0 1 0-2 0v2.25a1 1 0 1 0 2 0zM7.5 14.375a1 1 0 0 1 1 1v2.25a1 1 0 1 1-2 0v-2.25a1 1 0 0 1 1-1M22 10.875a1 1 0 1 0-2 0v2.25a1 1 0 1 0 2 0z"
  }))));
};
export default SvgIconGooglePodcastsLogo;